import BaseApi from '../BaseApi';

class DoctorFeedbackApi extends BaseApi {
  public doctorGenerateLink(params: any) {
    return this.post('doctor-request-call/generate-link', params);
  }

  public doctorSuggestReservationDate(params: any) {
    return this.post('doctor-request-call/suggest-reservation-date', params);
  }

  public getByUserTreatment(userTreatmentId: number | string, params?: any) {
    return this.get(`user-treatments/${userTreatmentId}/last-feedback`, params);
  }

  public completeFeedback(userTreatmentId: number | string, payload?: any) {
    return this.post(`user-treatments/${userTreatmentId}/complete-feedback`, payload);
  }

  protected getSpecificApiPrefix(): string {
    return 'v2/managers/';
  }
}

export default DoctorFeedbackApi;
